import { CompareHelper } from '@barthauer/abc/core';
import { ValueChangedEvent } from 'devextreme/ui/switch';

export enum SettingsPageEnum {
  UserInfo,
  General,
  Layout,
  Password,
  Additional,
  Version,
}

export class AdditionalSettingsTab {
  caption: string;
  name: string;
  visibleIndex?: number;
  svgIcon?: string;
  component: any;
  tabs?: AdditionalSettingsTab[];
  settingsPageValue?: SettingsPageEnum | number;
  ParentId?: SettingsPageEnum | string;
}

export type AdditionalMenuSettingItem = BooleanMenuSetting;

export class BooleanMenuSetting {
  caption: string;
  name: string;
  enabled: boolean;
  value: boolean | string;
  parentVisibleIndex?: number;
  visibleIndex?: number;
  onBeforeSave?: () => Promise<boolean> | Promise<void>;
  onBeforeCancel?: () => Promise<boolean> | Promise<void>;
  valueChanged?: (e: ValueChangedEvent) => Promise<void>;
  private _errorMessage?: string;
  public get errorMessage(): string {
    return this._errorMessage;
  }
  public set errorMessage(value: string) {
    this._errorMessage = value;
  }
  constructor() {}
}

export class SettingsTab extends AdditionalSettingsTab {}

export interface SwitchValueChangingEvent {
  cancel?: boolean | PromiseLike<boolean> | PromiseLike<void>;
}

export class SettingsChangingEvent {
  private _value?: string | number | boolean;
  private _previousValue?: string | number | boolean;
  cancel?: () => Promise<boolean> | Promise<void>;
  private _errorMessage?: string;
  public get errorMessage(): string {
    return this._errorMessage;
  }
  public set errorMessage(value: string) {
    this._errorMessage = value;
  }

  public set value(v: string | number | boolean) {
    this._value = v;
    if (CompareHelper.isNullorEmpty(this._previousValue)) {
      this._previousValue = v;
    }
  }
  public get value(): string | number | boolean {
    return this._value;
  }

  public get previousValue(): string | number | boolean {
    return this._previousValue;
  }

  constructor(private v: string | number | boolean) {
    this.value = v;
  }

  public isChanged(): boolean {
    return this.value !== this.previousValue;
  }
}

export class SettingsCancellingEvent {
  cancel?: () => Promise<boolean> | Promise<void>;
  constructor() {}
}
